import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom'; // Necesario para navegar
import { Search, AlertCircle, MapPin, Star, MessageSquareQuote, User, ExternalLink } from 'lucide-react';
import PageTransition from '../../components/PageTransition'; // Tu componente de animación
import api from '../../api/axios';

export default function Home() {
  const [topReviews, setTopReviews] = useState([]);
  const [isBranchModalOpen, setIsBranchModalOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branches, setBranches] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isAttnDropdownOpen, setIsAttnDropdownOpen] = useState(false);
  const [isDetallesDropdownOpen, setIsDetallesDropdownOpen] = useState(false);
  const detallesButtonRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 1. Inicializamos el estado con una función para leer el localStorage al cargar
  const [isDark, setIsDark] = useState(() => {
    // Verificamos si ya existe una preferencia guardada
    const savedTheme = localStorage.getItem('theme');
    // Si existe, lo usamos; si no, podemos opcionalmente checar la preferencia del sistema
    return savedTheme === 'dark';
  });

  // 2. Este Effect se encarga de aplicar o quitar la clase 'dark' en el HTML
  useEffect(() => {
    const root = window.document.documentElement; // Accedemos a la etiqueta <html>

    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  // 3. Función simple para el botón (puedes pasarla a tus componentes)
  const toggleTheme = () => setIsDark(!isDark);
  // 1. ESTADOS PARA EL RASTREO
  const [trackingInput, setTrackingInput] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { activeTour, setActiveTour } = useOutletContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTour === 'sucursales') {
      setTimeout(() => {
        const element = document.getElementById('sucursales');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
    }
  }, [activeTour]);

  // 2. FUNCIÓN DE BÚSQUEDA Y NAVEGACIÓN
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!trackingInput.trim()) return;

    setLoading(true);
    setError(null);

    try {
      // CAMBIA EL FETCH POR ESTO:
      const response = await api.get(`/shipments/${trackingInput.toUpperCase()}`);

      // Si la petición es exitosa (Axios lanza error si no lo es)
      navigate('/rastreo', { state: { initialTracking: trackingInput.toUpperCase() } });

    } catch (err) {
      if (err.response?.status === 404) {
        setError("Esta guía no existe o no ha sido registrada.");
      } else {
        setError("Error de conexión con el servidor.");
      }
    } finally {
      setLoading(false);
    }
  };

  const metallicGradient = { background: 'linear-gradient(to bottom, #F1F1F1, #C1C1C1)' };
  const [branchInfo, setBranchInfo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Cargar Sucursales
        const branchesRes = await api.get('/branches');
        const rawBranches = branchesRes.data?.data || branchesRes.data;
        const allBranches = Array.isArray(rawBranches) ? rawBranches : [];
        setBranches(allBranches);

        // Detectar ubicación
        try {
          const ipRes = await fetch('https://ipwho.is/');
          const ipData = await ipRes.json();
          const city = ipData.city || '';

          const matched = allBranches.find(b =>
            b.city && (b.city.toLowerCase().includes(city.toLowerCase()) || b.name.toLowerCase().includes(city.toLowerCase()))
          ) || allBranches[0];

          setBranchInfo(matched);
        } catch (e) {
          if (allBranches.length > 0) setBranchInfo(allBranches[0]);
        }

        // Seleccionar sucursal matriz por defecto
        if (allBranches.length > 0) {
          const validBranches = allBranches.filter(b => b && b.name);
          const mainBranch = validBranches.find(b => b.is_main == 1 || b.is_main === true) || validBranches[0];
          if (mainBranch) {
            setSelectedBranch(mainBranch);
          }
        }

        // 2. Cargar Reseñas
        try {
          const reviewsRes = await api.get('/public-reviews');
          const rawReviews = reviewsRes.data?.data || reviewsRes.data;
          setTopReviews(Array.isArray(rawReviews) ? rawReviews.slice(0, 3) : []);
        } catch (e) {
          console.warn("Reseñas no disponibles de momento");
        }

      } catch (err) {
        console.error("Error al cargar datos iniciales:", err);
      }
    };
    fetchData();
  }, []);

  // Función auxiliar para generar el link
  const getWhatsAppLink = (message) => {
    const safeBranches = Array.isArray(branches) ? branches : [];
    if (branchInfo && branchInfo.phone && branchInfo.phone.trim() !== '') {
      return `https://wa.me/52${branchInfo.phone.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;
    }

    const mainBranch = safeBranches.find(b => b.is_main == 1 || b.is_main === true) || safeBranches[0];
    if (mainBranch && mainBranch.phone && mainBranch.phone.trim() !== '') {
      return `https://wa.me/52${mainBranch.phone.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;
    }

    return null;
  };
  const mensajeAtencion = "Hola, vengo de la web y me gustaría saber más acerca de sus servicios...";
  const mensajeDetalles = "Hola, vengo de la web y quiero conocer los detalles de sus soluciones integrales.";
  return (
    <PageTransition>
      {/* 3. CONTENEDOR DE CONTENIDO (Ya no lleva fondos aquí, están en el Layout) */}
      <div className={`relative w-full flex flex-col items-center overflow-x-hidden pb-20 transition-all duration-500 ${activeTour ? 'z-[90]' : 'z-30'}`}>
        {(activeTour === 'rastreo' || activeTour === 'sucursales') && (
          <div 
            className="fixed inset-0 bg-black/75 backdrop-blur-sm z-40 pointer-events-auto"
            onClick={() => window.dispatchEvent(new CustomEvent('tbt-close-tour'))} 
          />
        )}

        {/* ========================================================
              1. PANEL DE RASTREO (CORRECCIÓN DE COLORES DARK)
              ======================================================== */}
        {isMobile ? (
          /* VERSIÓN MÓVIL (Buscador Cuadrado Gigante) */
          <form onSubmit={handleSearch} className={`relative flex flex-col items-center drop-shadow-[0_20px_30px_rgba(0,0,0,0.3)] mt-10 transition-all duration-500 ${activeTour === 'rastreo' ? 'z-50 scale-105' : 'z-10'}`}>
            {activeTour === 'rastreo' && (
              <div className="absolute -inset-3 border-[4px] border-[#CE010B] dark:border-[#FF3333] rounded-[3rem] shadow-[0_0_35px_rgba(206,1,11,0.8)] animate-pulse pointer-events-none z-20" />
            )}
            {/* Solapa Metálica */}
            <div className="border-[1.5px] border-black dark:border-white rounded-full px-20 py-6 z-10 -mb-10 shadow-sm transition-all duration-500 bg-gradient-to-b from-[#e8e8e8] via-[#c0c0c0] to-[#e8e8e8] dark:from-[#2a2a2a] dark:to-[#000000]">
              <div className="flex flex-col items-center leading-none">
                <span className="text-3xl font-black text-black dark:text-white uppercase tracking-widest" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Rastrea
                </span>
                <span className="text-3xl font-black text-black dark:text-white uppercase tracking-widest" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Ahora
                </span>
              </div>
            </div>

            {/* Rectángulo Principal */}
            <div className="border-[1.5px] rounded-[2.5rem] flex flex-col items-center gap-6 shadow-2xl transition-all duration-500 w-[420px] h-[420px] max-w-[92vw] justify-center p-10 bg-[#CE010B] border-black dark:bg-gradient-to-b dark:from-tbt-red-top dark:to-tbt-red-bottom dark:border-white">
              <label className="text-white text-3xl font-black text-center leading-snug whitespace-normal uppercase tracking-tight" style={{ fontFamily: "'Secular One', sans-serif" }}>
                Ingresa el número de guía:
              </label>

              <div className="flex flex-col items-center gap-4 w-full">
                <input
                  type="text"
                  value={trackingInput}
                  onChange={(e) => setTrackingInput(e.target.value)}
                  className="bg-white dark:bg-neutral-950 border-[1.5px] border-black dark:border-white/40 rounded-xl focus:outline-none text-black dark:text-white shadow-inner placeholder:text-gray-400 dark:placeholder:text-gray-600 uppercase font-bold transition-all w-full py-8 px-8 text-center text-2xl"
                  placeholder="TBT-########"
                />

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-5 bg-black dark:bg-white text-white dark:text-black rounded-xl hover:bg-zinc-800 dark:hover:bg-gray-200 transition-all active:scale-95 disabled:opacity-50 flex items-center justify-center gap-3 shadow-md"
                >
                  {loading ? (
                    <div className="animate-spin h-6 w-6 border-2 border-current border-t-transparent rounded-full" />
                  ) : (
                    <>
                      <Search size={28} />
                      <span className="font-black uppercase text-xl tracking-wider">Buscar Guía</span>
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* Error de búsqueda */}
            {error && (
              <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 flex items-center gap-2 text-[#CE010B] dark:text-white bg-white dark:bg-neutral-900 px-4 py-1.5 rounded-full border border-black dark:border-white text-xs font-bold animate-pulse shadow-md transition-all whitespace-nowrap">
                <AlertCircle size={14} /> {error}
              </div>
            )}
          </form>
        ) : (
          /* VERSIÓN WEB / DESKTOP (100% FIEL A TU CÓDIGO DE REFERENCIA) */
          <form onSubmit={handleSearch} className={`relative flex flex-col items-start drop-shadow-[0_20px_30px_rgba(0,0,0,0.3)] mt-10 transition-all duration-500 ${activeTour === 'rastreo' ? 'z-50 scale-105' : 'z-10'}`}>
            {activeTour === 'rastreo' && (
              <div className="absolute -inset-3 border-[4px] border-[#CE010B] dark:border-[#FF3333] rounded-[3rem] shadow-[0_0_35px_rgba(206,1,11,0.8)] animate-pulse pointer-events-none z-20" />
            )}
            {/* Solapa Metálica */}
            <div
              className="
                /* Base y Bordes */
                border-[1.5px] border-black dark:border-white rounded-full px-8 py-2 z-10 -mb-5 ml-6 shadow-sm transition-all duration-500
                
                /* MODO CLARO: El degradado metálico original con 3 puntos de color */
                bg-gradient-to-b from-[#e8e8e8] via-[#c0c0c0] to-[#e8e8e8]
                
                /* MODO OSCURO: El acero pavonado (negro/gris) */
                dark:from-[#2a2a2a] dark:to-[#000000]
              "
            >
              <div className="flex flex-col items-center leading-none">
                <span className="text-[20px] font-regular text-black dark:text-white uppercase tracking-widest" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Rastrea
                </span>
                <span className="text-[20px] font-regular text-black dark:text-white uppercase tracking-widest" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Ahora
                </span>
              </div>
            </div>

            {/* Rectángulo Principal */}
            <div className="
              /* Estructura Base */
              border-[1.5px] rounded-[2rem] px-10 py-6 flex flex-col md:flex-row items-center gap-6 shadow-2xl transition-all duration-500
              
              /* MODO CLARO (Default) */
              bg-[#CE010B] border-black
              
              /* MODO OSCURO (Overrides) */
              dark:bg-gradient-to-b dark:from-tbt-red-top dark:to-tbt-red-bottom dark:border-white
            ">
              <label className="text-white text-[20px] font-regular whitespace-nowrap" style={{ fontFamily: "'Secular One', sans-serif" }}>
                Ingresa el número de guía:
              </label>

              <div className="relative flex items-center">
                <input
                  type="text"
                  value={trackingInput}
                  onChange={(e) => setTrackingInput(e.target.value)}
                  className="bg-white dark:bg-neutral-950 border-[1.5px] border-black dark:border-white/40 rounded-xl px-5 py-2.5 w-full md:w-[350px] focus:outline-none text-black dark:text-white text-lg shadow-inner placeholder:text-gray-400 dark:placeholder:text-gray-600 uppercase font-bold transition-all"
                  placeholder="TBT-########"
                />

                <button
                  type="submit"
                  disabled={loading}
                  className="absolute right-2 bg-black dark:bg-white text-white dark:text-black p-2 rounded-lg hover:bg-zinc-800 dark:hover:bg-gray-200 transition-all active:scale-95 disabled:opacity-50"
                >
                  {loading ? (
                    <div className="animate-spin h-5 w-5 border-2 border-current border-t-transparent rounded-full" />
                  ) : (
                    <Search size={20} />
                  )}
                </button>
              </div>
            </div>

            {/* Error de búsqueda */}
            {error && (
              <div className="absolute -bottom-10 left-6 flex items-center gap-2 text-[#CE010B] dark:text-white bg-white dark:bg-neutral-900 px-4 py-1 rounded-full border border-black dark:border-white text-xs font-bold animate-pulse shadow-md transition-all">
                <AlertCircle size={14} /> {error}
              </div>
            )}
          </form>
        )}

        {/* 2. LEMA (Se mantiene igual, adaptando el tamaño de fuente) */}
        {/* 2. LEMA (Se mantiene igual, adaptando el tamaño de fuente) */}
        <div className="mt-10 flex flex-col items-center w-full max-w-[92%] md:max-w-[680px] lg:max-w-5xl px-4 lg:px-10">
          <h2
            className="text-white text-center leading-tight mb-2 italic"
            style={{
              fontSize: isMobile ? '30px' : '45px',
              fontFamily: "'Secular One', sans-serif",
              fontWeight: '400',
              textShadow: '0 0 20px rgba(0, 0, 0, 1), 0 0 10px rgba(0, 0, 0, 1)'
            }}
          >
            Soluciones que conectan destinos
          </h2>
          <div className="w-full h-[3.5px] bg-white mt-4" style={{ boxShadow: '0 0 15px rgba(0, 0, 0, 0.9), 0 0 5px rgba(0, 0, 0, 0.9)' }}></div>
        </div>

        {/* ========================================================
          3. PANEL DE ENVÍO URGENTE (ADAPTADO A DARK MODE)
          ======================================================== */}
        <div
          className="
          mt-10 w-full max-w-[92%] md:max-w-[680px] lg:max-w-5xl border-[1.5px] rounded-[3rem] min-h-[480px] pb-12 lg:pb-0 relative overflow-visible shadow-2xl transition-all duration-500
          
          /* MODO CLARO: Gradiente original */
          bg-gradient-to-b from-white to-[#C1C1C1] border-black
          
          /* MODO OSCURO: Degradado Rojo corporativo usando Hexadecimales puros */
          dark:from-[#590000] dark:to-[#780000] dark:border-white
        "
        >
          {/* IMAGEN MODO CLARO (Se oculta en dark y móviles) */}
          <img
            src="/camioneta.png"
            alt="Camioneta Blanca"
            className="hidden lg:block absolute left-[-250px] top-[-50px] w-[95%] h-auto object-contain z-20 pointer-events-none drop-shadow-2xl dark:hidden"
          />

          {/* IMAGEN MODO OSCURO (Se oculta en light y móviles) */}
          <img
            src="/camionetaoscuro.png"
            alt="Camioneta Negra"
            className="hidden lg:dark:block absolute left-[-175px] top-[-50px] w-[95%] h-auto object-contain z-20 pointer-events-none drop-shadow-[0_10px_20px_rgba(255,255,255,0.1)]"
          />

          {/* Contenedor de contenido adaptable */}
          <div className="flex flex-col items-center lg:items-end w-full px-6 lg:pr-12 pt-10 relative z-10">

            {/* Título */}
            <h3
              className="text-3xl md:text-[50px] font-bold text-black dark:text-white mb-6 lg:mb-2 uppercase tracking-tighter leading-[0.9] text-center lg:text-right transition-colors"
              style={{ fontFamily: "'Secular One', sans-serif" }}
            >
              ¿Necesitas un envío <br /> <span className="text-[#CE010B] dark:text-red-500">URGENTE?</span>
            </h3>

            {/* Fila Horizontal para Móvil: Camioneta Izquierda, Mapa Derecha */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8 w-full max-w-[900px] lg:flex-col lg:items-end lg:gap-0 lg:max-w-none">
              {/* Camioneta (se muestra al lado izquierdo en móvil, y se oculta en desktop) */}
              <div className="block lg:hidden w-full md:w-[70%] max-w-[550px] pointer-events-none transition-all duration-300 md:-ml-20 dark:md:-ml-8 lg:ml-0 mx-auto">
                {/* Camioneta Claro */}
                <img
                  src="/camioneta.png"
                  alt="Camioneta Express"
                  className="block dark:hidden w-full h-auto object-contain drop-shadow-xl"
                />
                {/* Camioneta Oscuro */}
                <img
                  src="/camionetaoscuro.png"
                  alt="Camioneta Express Negra"
                  className="hidden dark:block w-full h-auto object-contain drop-shadow-[0_10px_20px_rgba(255,255,255,0.15)]"
                />
              </div>

              {/* ÁREA DEL MAPA — solo visible en móvil dentro de la fila */}
              <div className="block lg:hidden relative w-full md:w-[30%] max-w-[280px] h-44 mx-auto">
                <svg className="absolute inset-0 w-full h-full -z-10" style={{ pointerEvents: 'none' }}>
                  <line
                    x1="15%" y1="80%"
                    x2="85%" y2="20%"
                    className="stroke-black dark:stroke-white transition-all duration-500"
                    strokeWidth="3"
                    strokeDasharray="10, 10"
                  />
                </svg>

                {/* PACHUCA */}
                <div className="absolute top-[80%] left-[15%] -translate-x-1/2 -translate-y-[10px] flex flex-col items-center">
                  <MapPin className="w-6 h-6 text-[#CE010B] drop-shadow-md z-20" fill="white" />
                  <span className="text-[12px] font-bold text-black dark:text-white uppercase mt-1 transition-colors duration-500" style={{ fontFamily: "'Secular One', sans-serif" }}>
                    Pachuca
                  </span>
                </div>

                {/* CDMX */}
                <div className="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-[10px] flex flex-col items-center">
                  <MapPin className="w-6 h-6 text-[#CE010B] drop-shadow-md z-20" fill="white" />
                  <span className="text-[12px] font-bold text-black dark:text-white uppercase mt-1 transition-colors duration-500" style={{ fontFamily: "'Secular One', sans-serif" }}>
                    CDMX
                  </span>
                </div>

                {/* TOLUCA */}
                <div className="absolute top-[20%] left-[85%] -translate-x-1/2 -translate-y-[10px] flex flex-col items-center">
                  <MapPin className="w-6 h-6 text-[#CE010B] drop-shadow-md z-20" fill="white" />
                  <span className="text-[12px] font-bold text-black dark:text-white uppercase mt-1 transition-colors duration-500" style={{ fontFamily: "'Secular One', sans-serif" }}>
                    Toluca
                  </span>
                </div>
              </div>
            </div>

            {/* TEXTO ENVÍOS EXPRESS + MAPA (Desktop: agrupados a la derecha) */}
            <div className="text-center lg:text-right mt-6 lg:mt-4 lg:pr-4 flex flex-col lg:items-end gap-2">

              {/* ÁREA DEL MAPA — solo visible en desktop, encima del texto */}
              <div className="hidden lg:block relative w-[340px] h-44 ml-auto">
                <svg className="absolute inset-0 w-full h-full -z-10" style={{ pointerEvents: 'none' }}>
                  <line
                    x1="15%" y1="80%"
                    x2="85%" y2="20%"
                    className="stroke-black dark:stroke-white transition-all duration-500"
                    strokeWidth="3"
                    strokeDasharray="10, 10"
                  />
                </svg>

                {/* PACHUCA */}
                <div className="absolute top-[80%] left-[15%] -translate-x-1/2 -translate-y-[10px] flex flex-col items-center">
                  <MapPin className="w-6 h-6 text-[#CE010B] drop-shadow-md z-20" fill="white" />
                  <span className="text-[15px] font-bold text-black dark:text-white uppercase mt-1 transition-colors duration-500" style={{ fontFamily: "'Secular One', sans-serif" }}>
                    Pachuca
                  </span>
                </div>

                {/* CDMX */}
                <div className="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-[10px] flex flex-col items-center">
                  <MapPin className="w-6 h-6 text-[#CE010B] drop-shadow-md z-20" fill="white" />
                  <span className="text-[15px] font-bold text-black dark:text-white uppercase mt-1 transition-colors duration-500" style={{ fontFamily: "'Secular One', sans-serif" }}>
                    CDMX
                  </span>
                </div>

                {/* TOLUCA */}
                <div className="absolute top-[20%] left-[85%] -translate-x-1/2 -translate-y-[10px] flex flex-col items-center">
                  <MapPin className="w-6 h-6 text-[#CE010B] drop-shadow-md z-20" fill="white" />
                  <span className="text-[15px] font-bold text-black dark:text-white uppercase mt-1 transition-colors duration-500" style={{ fontFamily: "'Secular One', sans-serif" }}>
                    Toluca
                  </span>
                </div>
              </div>

              <p
                className="text-[#333] dark:text-gray-300 text-lg md:text-[25px] font-bold leading-tight transition-colors"
                style={{ fontFamily: "'Secular One', sans-serif" }}
              >
                *Envíos <span className="text-[#CE010B] dark:text-red-500">express</span> entre <br /> Pachuca, CDMX y Toluca
              </p>
            </div>

            {/* Bloques de horario centrado */}
            <div className="w-full text-center mt-12 lg:mt-24 px-4 lg:mr-0">
              <h4
                className="text-lg md:text-[35px] font-bold text-black dark:text-white uppercase tracking-tighter leading-none transition-colors"
                style={{ fontFamily: "'Secular One', sans-serif" }}
              >
                ¡Tráenos tu paquete!  <span className="text-[#CE010B] dark:text-red-500 block sm:inline">entre 9:00 | 13:00 hrs</span>
              </h4>
            </div>

            <div className="w-full text-center mt-4 lg:mt-5 px-4 lg:mr-0">
              <h4
                className="text-lg md:text-[35px] font-bold text-black dark:text-white uppercase tracking-tighter leading-none transition-colors"
                style={{ fontFamily: "'Secular One', sans-serif" }}
              >
                entregamos en sucursal  <span className="text-[#CE010B] dark:text-red-500 block sm:inline">hoy mismo</span>
              </h4>
            </div>
          </div>
        </div>
        {/* ========================================================
    4. SECCIÓN: SOMOS TU ALIADO ESTRATÉGICO
    ======================================================== */}
        {/* ========================================================
            4. SECCIÓN: SOMOS TU ALIADO ESTRATÉGICO - ESCRITORIO
            ======================================================== */}
        <div
          id="faq"
          className="mt-10 w-full max-w-5xl border-[1.5px] rounded-[3rem] min-h-[600px] relative overflow-visible shadow-2xl hidden lg:flex flex-row items-start px-12 pt-12 pb-12 gap-10 transition-all duration-500
             bg-gradient-to-b from-white to-[#C1C1C1] border-black 
             dark:bg-gradient-to-b dark:from-tbt-red-top dark:to-tbt-red-bottom dark:border-white"
        >
          {/* LADO IZQUIERDO: Contenido Persuasivo */}
          <div className="w-full md:w-[45%] flex flex-col items-center gap-6 pt-0">

            {/* 1. TÍTULO PRINCIPAL (Bloque Segmentado) */}
            <div className="w-full bg-[#CE010B] dark:bg-gradient-to-br dark:from-tbt-red-top dark:to-tbt-red-bottom rounded-[2rem] px-6 py-8 shadow-xl border border-black/10">
              <h2
                className="text-white text-5xl font-black tracking-tighter text-center leading-[0.9]"
                style={{ fontFamily: "'Secular One', sans-serif" }}
              >
                ¡POTENCIA TUS VENTAS!
              </h2>
            </div>

            {/* 2. SUBTÍTULO (Bloque Segmentado) */}
            <div className="w-full bg-white/50 dark:bg-black/20 rounded-[1.5rem] px-6 py-4 text-center border border-black/5 dark:border-white/10">
              <h3
                className="text-black dark:text-gray-100 text-2xl font-bold tracking-tight leading-[1.1]"
                style={{ fontFamily: "'Secular One', sans-serif" }}
              >
                Tus productos en buenas manos
              </h3>
            </div>

            {/* 3. DESCRIPCIÓN CON KEYWORDS (Bloque Segmentado) */}
            <div className="w-full bg-white/30 dark:bg-white/5 rounded-[1.5rem] px-6 py-5 text-center border border-black/5 dark:border-white/10">
              <p className="text-black dark:text-gray-300 text-[18px] font-medium leading-snug">
                Sabemos que detrás de cada envío hay un cliente esperando. Desde el envío de tus <span className="font-bold text-[#CE010B] dark:text-red-400">pedidos de emprendimiento</span> hasta el resurtido más <span className="font-bold text-[#CE010B] dark:text-red-400">urgente</span>, nosotros nos aseguramos de que tu mercancía llegue <span className="font-bold text-[#CE010B] dark:text-red-400">seguro y a tiempo</span>.
              </p>
            </div>

            {/* LÍNEA SEPARADORA */}
            <div className="w-full h-[3px] bg-[#CE010B] dark:bg-white transition-colors"></div>

            {/* PRECIO */}
            <div className="flex flex-col items-center">
              <h5
                className="text-[#CE010B] dark:text-white text-[42px] font-bold tracking-tighter text-center leading-none"
                style={{ fontFamily: "'Secular One', sans-serif" }}
              >
                Precios desde: $185
              </h5>
              <span className="mt-1 px-3 py-0.5 border border-[#CE010B]/30 dark:border-white/30 rounded-full text-[11px] font-bold text-[#CE010B] dark:text-gray-300 uppercase tracking-widest">
                * Aplica en envíos estándar
              </span>
            </div>
          </div>

          {/* LADO DERECHO: Imagen de impacto y Botones debajo */}
          <div className="w-full md:w-[55%] flex flex-col gap-6 items-center relative flex-shrink-0">
            <div className="w-full h-[300px] md:h-[580px] relative overflow-hidden rounded-[2.5rem] border-[1.5px] border-black/10 dark:border-white/20 shadow-2xl">
              <img
                src="Imagen_Ventas.png?v=2"
                alt="Negocio y logística"
                className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-110"
              />
            </div>
            {/* Resplandor */}
            <div className="absolute inset-0 -z-10 bg-[#CE010B] opacity-20 blur-[80px] rounded-full"></div>

            {/* BOTONES DE ACCIÓN (Lógica original preservada, tamaño y dirección responsivos) */}
            <div className="flex flex-col lg:flex-row gap-4 mt-2 w-full items-center justify-center">
              {/* BOTÓN ATENCIÓN PERSONALIZADA CON DROPDOWN */}
              <div className="relative">
                <button
                  onClick={() => setIsAttnDropdownOpen(prev => !prev)}
                  onBlur={() => setTimeout(() => setIsAttnDropdownOpen(false), 150)}
                  className="border-[1.5px] border-black dark:border-white rounded-[2rem] px-6 py-4 lg:px-5 lg:py-3 flex items-center justify-center gap-4 lg:gap-3 shadow-md hover:scale-105 transition-all bg-gradient-to-b from-white to-[#E5E5E5] dark:from-neutral-800 dark:to-black w-full max-w-[320px] lg:w-auto cursor-pointer"
                >
                  <div className="flex flex-col text-left leading-none">
                    <span className="text-black dark:text-white text-[18px] lg:text-[16px] font-bold lg:font-regular">Atención</span>
                    <span className="text-black dark:text-white text-[18px] lg:text-[16px] font-bold lg:font-regular">Personalizada</span>
                  </div>
                  <div className="bg-[#25D366] p-1 rounded-full shadow-sm flex items-center justify-center w-10 h-10 lg:w-9 lg:h-9 overflow-hidden shrink-0">
                    <img src="/whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" />
                  </div>
                </button>

                {/* Dropdown de sucursales */}
                {isAttnDropdownOpen && (
                  <div className="absolute bottom-full mb-2 left-0 z-50 bg-white dark:bg-neutral-900 border border-black/10 dark:border-white/20 rounded-2xl shadow-xl overflow-hidden min-w-[220px]">
                    {branches
                      .filter(b => b.phone && b.phone.trim() !== '')
                      .map(branch => (
                        <a
                          key={branch.id}
                          href={`https://wa.me/52${branch.phone.replace(/\D/g, '')}?text=${encodeURIComponent(mensajeAtencion)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-3 px-5 py-3 hover:bg-[#CE010B] hover:text-white transition-colors group no-underline"
                        >
                          <div className="bg-[#25D366] p-1 rounded-full flex items-center justify-center w-7 h-7 overflow-hidden shrink-0">
                            <img src="/whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" />
                          </div>
                          <span className="text-black dark:text-white group-hover:text-white text-[15px] font-semibold">{branch.name}</span>
                        </a>
                      ))
                    }
                  </div>
                )}
              </div>

              <button
                onClick={() => navigate('/cotizar')}
                className="border-[1.5px] border-black dark:border-white rounded-[2rem] px-6 py-4 lg:px-6 lg:py-3 flex items-center justify-center gap-4 lg:gap-3 shadow-md hover:scale-105 transition-all bg-gradient-to-b from-white to-[#E5E5E5] dark:from-neutral-900 dark:to-black w-full max-w-[320px] lg:w-auto"
              >
                <div className="flex flex-col text-left leading-none">
                  <span className="text-black dark:text-white text-[18px] lg:text-[16px] font-bold lg:font-regular">Cotiza en</span>
                  <span className="text-black dark:text-white text-[18px] lg:text-[16px] font-bold lg:font-regular">línea</span>
                </div>
                <div className="bg-[#CE010B] dark:bg-white text-white dark:text-black rounded-full flex items-center justify-center w-10 h-10 lg:w-9 lg:h-9 shrink-0 shadow-sm transition-colors">
                  <svg className="w-6 h-6 lg:w-5 lg:h-5 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="6" width="20" height="12" rx="2" /><circle cx="12" cy="12" r="2" /><path d="M6 12h.01M18 12h.01" strokeWidth="2" />
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* ========================================================
            4. SECCIÓN: SOMOS TU ALIADO ESTRATÉGICO - MÓVIL
            ======================================================== */}
        <div
          className="mt-10 w-full max-w-[92%] md:max-w-[680px] lg:max-w-5xl border-[1.5px] rounded-[3rem] relative overflow-visible shadow-2xl flex lg:hidden flex-col items-center px-6 py-10 gap-6 transition-all duration-500
             bg-gradient-to-b from-white to-[#C1C1C1] border-black 
             dark:bg-gradient-to-b dark:from-tbt-red-top dark:to-tbt-red-bottom dark:border-white"
        >
          {/* 1. TÍTULO PRINCIPAL (Bloque Segmentado) */}
          <div className="w-full bg-[#CE010B] dark:bg-gradient-to-br dark:from-tbt-red-top dark:to-tbt-red-bottom rounded-[2rem] px-6 py-6 shadow-xl border border-black/10 animate-pulse">
            <h2
              className="text-white text-6xl font-black tracking-tighter text-center leading-[0.9]"
              style={{ fontFamily: "'Secular One', sans-serif" }}
            >
              ¡POTENCIA TUS VENTAS!
            </h2>
          </div>

          {/* 2. SUBTÍTULO (Bloque Segmentado) */}
          <div className="w-full bg-white/50 dark:bg-black/20 rounded-[1.5rem] px-6 py-4 text-center border border-black/5 dark:border-white/10">
            <h3
              className="text-black dark:text-gray-100 text-[30px] font-bold tracking-tight leading-[1.1]"
              style={{ fontFamily: "'Secular One', sans-serif" }}
            >
              Tus productos en buenas manos
            </h3>
          </div>

          {/* IMAGEN DE IMPACTO (MOVIDA MÁS ARRIBA A LA ALTURA DEL TÍTULO/CONTENIDO) */}
          <div className="w-full h-[280px] relative flex-shrink-0">
            <div className="w-full h-full relative overflow-hidden rounded-[2.5rem] border-[1.5px] border-black/10 dark:border-white/20 shadow-2xl">
              <img
                src="Imagen_Ventas.png?v=2"
                alt="Negocio y logística"
                className="w-full h-full object-cover object-center"
              />
            </div>
            {/* Resplandor */}
            <div className="absolute inset-0 -z-10 bg-[#CE010B] opacity-20 blur-[60px] rounded-full"></div>
          </div>

          {/* BOTONES DE ACCIÓN (UBICADOS JUSTO DEBAJO DE LA IMAGEN) */}
          <div className="flex flex-row flex-wrap gap-4 w-full justify-center">
            {/* BOTÓN ATENCIÓN PERSONALIZADA CON DROPDOWN */}
            <div className="relative flex-1 min-w-[150px]">
              <button
                onClick={() => setIsAttnDropdownOpen(prev => !prev)}
                onBlur={() => setTimeout(() => setIsAttnDropdownOpen(false), 150)}
                className="border-[1.5px] border-black dark:border-white rounded-[2rem] px-4 py-3 flex items-center justify-center gap-3 shadow-md hover:scale-105 transition-all bg-gradient-to-b from-white to-[#E5E5E5] dark:from-neutral-800 dark:to-black w-full cursor-pointer"
              >
                <div className="flex flex-col text-left leading-none">
                  <span className="text-black dark:text-white text-[22px] font-bold">Atención</span>
                  <span className="text-black dark:text-white text-[22px] font-bold">Personalizada</span>
                </div>
                <div className="bg-[#25D366] p-1 rounded-full shadow-sm flex items-center justify-center w-8 h-8 overflow-hidden shrink-0">
                  <img src="/whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" />
                </div>
              </button>

              {/* Dropdown de sucursales */}
              {isAttnDropdownOpen && (
                <div className="absolute bottom-full mb-2 left-0 z-50 bg-white dark:bg-neutral-900 border border-black/10 dark:border-white/20 rounded-2xl shadow-xl overflow-hidden min-w-[200px]">
                  {branches
                    .filter(b => b.phone && b.phone.trim() !== '')
                    .map(branch => (
                      <a
                        key={branch.id}
                        href={`https://wa.me/52${branch.phone.replace(/\D/g, '')}?text=${encodeURIComponent(mensajeAtencion)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 px-4 py-3 hover:bg-[#CE010B] hover:text-white transition-colors group no-underline"
                      >
                        <div className="bg-[#25D366] p-1 rounded-full flex items-center justify-center w-7 h-7 overflow-hidden shrink-0">
                          <img src="/whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" />
                        </div>
                        <span className="text-black dark:text-white group-hover:text-white text-[14px] font-semibold">{branch.name}</span>
                      </a>
                    ))
                  }
                </div>
              )}
            </div>

            <button
              onClick={() => navigate('/cotizar')}
              className="border-[1.5px] border-black dark:border-white rounded-[2rem] px-5 py-3 flex items-center justify-center gap-3 shadow-md hover:scale-105 transition-all bg-gradient-to-b from-white to-[#E5E5E5] dark:from-neutral-900 dark:to-black flex-1 min-w-[150px]"
            >
              <div className="flex flex-col text-left leading-none">
                <span className="text-black dark:text-white text-[22px] font-bold">Cotiza en</span>
                <span className="text-black dark:text-white text-[22px] font-bold">línea</span>
              </div>
              <div className="bg-[#CE010B] dark:bg-white text-white dark:text-black rounded-full flex items-center justify-center w-8 h-8 shrink-0 shadow-sm transition-colors">
                <svg className="w-5 h-5 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="6" width="20" height="12" rx="2" /><circle cx="12" cy="12" r="2" /><path d="M6 12h.01M18 12h.01" strokeWidth="2" />
                </svg>
              </div>
            </button>
          </div>

          {/* 3. DESCRIPCIÓN CON KEYWORDS (UBICADA DEBAJO DE LOS BOTONES) */}
          <div className="w-full bg-white/30 dark:bg-white/5 rounded-[1.5rem] px-6 py-5 text-center border border-black/5 dark:border-white/10">
            <p className="text-black dark:text-gray-300 text-[24px] font-medium leading-snug">
              Sabemos que detrás de cada envío hay un cliente esperando. Desde el envío de tus <span className="font-bold text-[#CE010B] dark:text-red-400">pedidos de emprendimiento</span> hasta el resurtido más <span className="font-bold text-[#CE010B] dark:text-red-400">urgente</span>, nosotros nos aseguramos de que tu mercancía llegue <span className="font-bold text-[#CE010B] dark:text-red-400">seguro y a tiempo</span>.
            </p>
          </div>

          {/* LÍNEA SEPARADORA */}
          <div className="w-full h-[3px] bg-[#CE010B] dark:bg-white transition-colors"></div>

          {/* PRECIO */}
          <div className="flex flex-col items-center">
            <h5
              className="text-[#CE010B] dark:text-white text-[48px] font-bold tracking-tighter text-center leading-none"
              style={{ fontFamily: "'Secular One', sans-serif" }}
            >
              Precios desde: $185
            </h5>
            <span className="mt-1 px-3 py-0.5 border border-[#CE010B]/30 dark:border-white/30 rounded-full text-[16px] font-bold text-[#CE010B] dark:text-gray-300 uppercase tracking-widest">
              * Aplica en envíos estándar
            </span>
          </div>
        </div>
        {/* ========================================================
    SECCIÓN INTEGRADA: ENCUÉNTRANOS
    ======================================================== */}
        <section 
          id="sucursales" 
          className={`mt-16 w-full max-w-[92%] md:max-w-[680px] lg:max-w-5xl px-4 lg:px-0 transition-all duration-500 relative ${
            activeTour === 'sucursales' ? 'z-50 scale-[1.02]' : 'z-10'
          }`}
        >
          {activeTour === 'sucursales' && (
            <div className="absolute -inset-3 border-[4px] border-[#CE010B] dark:border-[#FF3333] rounded-[3.5rem] shadow-[0_0_35px_rgba(206,1,11,0.8)] animate-pulse pointer-events-none z-20" />
          )}
          {/* APLICADO EL GRADIENTE EN MODO DARK */}
          <div className="bg-white border-[1.5px] border-black rounded-[3rem] p-8 lg:p-12 shadow-2xl transition-all duration-500 
                  dark:border-white 
                  dark:bg-gradient-to-b dark:from-[#590000] dark:to-[#780000]">

            {/* TÍTULO LLAMATIVO */}
            <div className="mb-10 text-center">
              <h2 className="text-7xl lg:text-5xl font-black uppercase tracking-tighter text-[#CE010B] dark:text-white transition-all">
                ENCUÉNTRANOS
              </h2>
              <div className="flex items-center justify-center gap-2 mt-2">
                <div className="h-[2px] w-12 bg-[#CE010B]"></div>
                <p className="text-gray-500 dark:text-gray-300 font-bold uppercase tracking-widest text-base lg:text-xs">Nuestras sedes operativas</p>
                <div className="h-[2px] w-12 bg-[#CE010B]"></div>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-10">
              {/* Selector de Sucursal */}
              <div className="w-full lg:w-1/3 space-y-4">
                <select
                  value={selectedBranch?.id || ''}
                  onChange={(e) => {
                    const found = branches.find(b => b.id.toString() === e.target.value);
                    setSelectedBranch(found);
                  }}
                  className="w-full p-5 rounded-2xl bg-gray-100 dark:bg-black/30 border-[1.5px] border-black/10 dark:border-white/20 font-bold text-xl lg:text-sm outline-none text-black dark:text-white cursor-pointer transition-colors"
                >
                  <option value="" className="text-black">-- Elige una Sucursal --</option>
                  {(Array.isArray(branches) ? branches : [])
                    .filter(b => b && b.name && (
                      (b.phone && b.phone.trim() !== '') ||
                      (b.direccion && b.direccion.trim() !== '') ||
                      (b.email_contacto && b.email_contacto.trim() !== '')
                    ))
                    .map(b => (
                      <option key={b.id} value={b.id} className="text-black">
                        {b.name}
                      </option>
                    ))
                  }
                </select>

                {/* Info de la sucursal */}
                {selectedBranch && (
                  <div className="p-6 bg-[#CE010B]/5 border border-[#CE010B]/20 rounded-2xl space-y-3 animate-in fade-in duration-500 dark:bg-black/30 dark:border-white/10 transition-colors">
                    <p className="text-xl lg:text-sm font-black uppercase text-[#CE010B] dark:text-red-400">{selectedBranch.name}</p>
                    <p className="text-base lg:text-xs opacity-70 dark:text-gray-300">{selectedBranch.direccion}</p>
                    <p className="text-base lg:text-xs font-bold text-gray-600 dark:text-gray-400">Tel: {selectedBranch.phone}</p>
                    
                    {/* Botón interactivo: Ver en Google Maps */}
                    <a
                      href={selectedBranch.google_maps_url || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("Más Envíos " + selectedBranch.name + " " + (selectedBranch.direccion || selectedBranch.city || ''))}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-4 py-2.5 bg-[#CE010B] hover:bg-[#b00109] text-white text-xs font-black uppercase tracking-wider rounded-xl shadow-md transition-all duration-300 hover:scale-[1.03] active:scale-95 mt-2"
                    >
                      <MapPin size={16} className="text-white shrink-0" />
                      <span>Abrir en Google Maps</span>
                      <ExternalLink size={14} className="text-white/80 shrink-0" />
                    </a>
                  </div>
                )}
              </div>

              {/* Mapa dinámico */}
              <div className="w-full lg:w-2/3 h-80 rounded-3xl overflow-hidden border-[1.5px] border-black/10 dark:border-white/20 shadow-inner bg-gray-100 dark:bg-black/30 flex items-center justify-center transition-colors">
                {selectedBranch && selectedBranch.lat && selectedBranch.lng ? (
                  <iframe
                    title="Mapa Sucursal"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    src={`https://maps.google.com/maps?q=${selectedBranch.lat},${selectedBranch.lng}&output=embed`}
                    allowFullScreen
                    className="filter dark:invert-[0.9] dark:hue-rotate-180"
                  ></iframe>
                ) : (
                  <div className="text-gray-400 flex flex-col items-center p-6 text-center">
                    <MapPin size={48} className="mb-2 opacity-50" />
                    <span className="text-xl lg:text-sm font-bold uppercase">Selecciona una sucursal para ver su ubicación</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* ========================================================
    SECCIÓN: RESEÑAS DESTACADAS
    ======================================================== */}
        {topReviews && topReviews.length > 0 && (
          <section className="mt-20 w-3/4 mx-auto lg:w-full lg:max-w-5xl px-4 lg:px-0 mb-20">
            <div className="text-center mb-12">
              <h2 className="text-5xl font-black uppercase tracking-tighter text-white">
                ¿Qué dicen nuestros clientes?
              </h2>
              <div className="flex items-center justify-center gap-2 mt-2">
                <div className="h-[2px] w-12 bg-[#CE010B]"></div>
                <p className="text-gray-500 font-bold uppercase tracking-widest text-xs">Opiniones Reales</p>
                <div className="h-[2px] w-12 bg-[#CE010B]"></div>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {topReviews.map((review) => (
                <div
                  key={review.id || Math.random()}
                  className="p-10 lg:p-8 rounded-[2.5rem] shadow-xl relative group overflow-hidden border border-black/5 dark:border-white/10
                           bg-[linear-gradient(180deg,#F1F1F1_0%,#C1C1C1_100%)] 
                           dark:bg-[linear-gradient(180deg,#590000_0%,#780000_100%)]"
                >
                  <MessageSquareQuote className="absolute top-6 right-6 text-black/10 dark:text-white/10" size={50} />
                  <div className="space-y-4 relative z-10">
                    <div className="flex items-center gap-3">
                      <div className="w-14 h-14 lg:w-10 lg:h-10 bg-black/10 dark:bg-black/30 rounded-full flex items-center justify-center text-black dark:text-white">
                        <User className="w-8 h-8 lg:w-5 lg:h-5" />
                      </div>
                      <div>
                        <p className="font-black text-3xl lg:text-sm uppercase text-black dark:text-white">
                          {review.user?.name || 'Socio Anónimo'}
                        </p>
                        {review.created_at && (
                          <p className="text-gray-500 dark:text-white/40 text-lg lg:text-[10px] font-bold mt-0.5">
                            {new Date(review.created_at).toLocaleDateString('es-ES', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric'
                            })}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="flex gap-1">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <Star
                          key={star}
                          className={`w-8 h-8 lg:w-3.5 lg:h-3.5 ${star <= (review.rating || 0) ? 'text-yellow-400 fill-yellow-400' : 'text-gray-400'}`}
                        />
                      ))}
                    </div>

                    <p className="text-gray-900 dark:text-white italic text-2xl lg:text-xs font-normal leading-relaxed line-clamp-3">
                      "{review.comment || 'Sin comentarios'}"
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}
        {/* ========================================================
    6. SECCIÓN: SOLUCIONES INTEGRALES (TEXTO + BOTÓN)
    ======================================================== */}
        <div id="empresa" className="mt-8 w-full max-w-[92%] md:max-w-[680px] lg:max-w-5xl flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-10 mb-8 px-4 lg:px-0">

          {/* Texto a la izquierda: Soluciones integrales */}
          <h2
            className="text-5xl md:text-[35px] font-regular text-white uppercase tracking-tighter leading-[0.95] text-center lg:text-left"
            style={{ fontFamily: "'Secular One', sans-serif" }}
          >
            Soluciones integrales  <br />
            para tu negocio
          </h2>

          {/* Botón a la derecha: Conoce los detalles con Dropdown */}
          <div className="relative w-full max-w-[340px]">
            <button
              ref={detallesButtonRef}
              onClick={() => {
                if (isDetallesDropdownOpen) detallesButtonRef.current?.blur();
                setIsDetallesDropdownOpen(prev => !prev);
              }}
              onBlur={() => setTimeout(() => setIsDetallesDropdownOpen(false), 150)}
              className="flex items-center gap-4 border-[2.5px] border-white rounded-full px-10 py-5 hover:bg-white dark:hover:bg-black hover:text-black dark:hover:text-white focus-visible:outline-none transition-all duration-300 group shadow-[0_10px_20px_rgba(0,0,0,0.1)] active:scale-95 cursor-pointer w-full justify-center"
            >
              <span
                className="text-white text-[30px] md:text-[24px] font-regular uppercase tracking-tight group-hover:text-black dark:group-hover:text-white transition-colors"
                style={{ fontFamily: "'Secular One', sans-serif" }}
              >
                Conoce los detalles
              </span>
              <div className="bg-[#25D366] p-1.5 rounded-full shadow-md group-hover:scale-110 transition-transform w-11 h-11 flex items-center justify-center overflow-hidden">
                <img src="whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" />
              </div>
            </button>

            {/* Dropdown de sucursales */}
            {isDetallesDropdownOpen && (
              <div className="absolute top-full mt-2 left-0 z-50 bg-white dark:bg-neutral-900 border border-black/10 dark:border-white/20 rounded-2xl shadow-xl overflow-hidden min-w-[220px]">
                {branches
                  .filter(b => b.phone && b.phone.trim() !== '')
                  .map(branch => (
                    <a
                      key={branch.id}
                      href={`https://wa.me/52${branch.phone.replace(/\D/g, '')}?text=${encodeURIComponent(mensajeDetalles)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 px-5 py-3 hover:bg-[#CE010B] hover:text-white transition-colors group no-underline"
                    >
                      <div className="bg-[#25D366] p-1 rounded-full flex items-center justify-center w-7 h-7 overflow-hidden shrink-0">
                        <img src="/whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" />
                      </div>
                      <span className="text-black dark:text-white group-hover:text-white text-[22px] lg:text-[15px] font-semibold">{branch.name}</span>
                    </a>
                  ))
                }
              </div>
            )}
          </div>
        </div>
        {/* ========================================================
    7. SECCIÓN: SERVICIOS (FONDO ROJO DARK MODE)
    ======================================================== */}
        {isMobile ? (
          /* MÓVIL: Tarjetas Horizontales en 1 Columna */
          <div className="mt-0 w-full max-w-[92%] md:max-w-[680px] lg:max-w-5xl grid grid-cols-1 gap-8 mb-0 px-4 lg:px-0">
            {/* TARJETA 1 */}
            <div className="border-[1.5px] border-black dark:border-white rounded-[3rem] flex flex-row items-center p-6 shadow-2xl relative overflow-hidden h-auto transition-all duration-500
      bg-gradient-to-b from-white to-[#F08888]
      dark:from-[#590000] dark:to-[#780000]"
            >
              {/* Contenedor del ícono */}
              <div className="flex-shrink-0 flex justify-center items-center w-24 h-24 relative">
                <img src="png1.png" alt="Carga Consolidada Claro" className="w-20 h-20 object-contain drop-shadow-lg dark:hidden" />
                <img src="png1_oscuro.png" alt="Carga Consolidada Oscuro" className="w-20 h-20 object-contain drop-shadow-[0_10px_20px_rgba(255,255,255,0.1)] hidden dark:block" />
              </div>

              {/* Texto agrupado para alineación horizontal en móvil */}
              <div className="flex-grow flex flex-col items-start text-left mt-0 ml-6">
                <h3 className="text-[27px] font-bold text-black dark:text-white uppercase leading-tight tracking-tighter transition-colors" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Carga Consolidada (LTL)
                </h3>
                <p className="text-black dark:text-gray-300 text-[21px] font-medium leading-snug italic transition-colors mt-2">
                  ¿No llenas un camión completo? Paga solo por el espacio que ocupas. Ideal para tarimas y mercancía pesada.
                </p>
              </div>

              {/* Contenedor de la imagen inferior */}
              <div className="hidden sm:block w-36 h-24 rounded-3xl overflow-hidden shadow-sm bg-black/5 dark:bg-white/5 border-[1px] border-transparent dark:border-white/20 transition-colors flex-shrink-0 ml-6">
                <img src="imagen1.jpg" alt="Servicio Claro" className="w-full h-full object-cover block dark:hidden" />
                <img src="imagen1.jpg" alt="Servicio Oscuro" className="w-full h-full object-cover hidden dark:block" />
              </div>
            </div>

            {/* TARJETA 2 */}
            <div className="border-[1.5px] border-black dark:border-white rounded-[3rem] flex flex-row items-center p-6 shadow-2xl relative overflow-hidden h-auto transition-all duration-500
      bg-gradient-to-b from-white to-[#F08888]
      dark:from-[#590000] dark:to-[#780000]"
            >
              {/* Contenedor del ícono */}
              <div className="flex-shrink-0 flex justify-center items-center w-24 h-24 relative">
                <img src="png2.png" alt="Almacenaje Claro" className="w-20 h-20 object-contain drop-shadow-lg dark:hidden" />
                <img src="png2_oscuro.png" alt="Almacenaje Oscuro" className="w-20 h-20 object-contain drop-shadow-[0_10px_20px_rgba(255,255,255,0.1)] hidden dark:block" />
              </div>

              {/* Texto agrupado para alineación horizontal en móvil */}
              <div className="flex-grow flex flex-col items-start text-left mt-0 ml-6">
                <h3 className="text-[27px] font-bold text-black dark:text-white uppercase leading-tight tracking-tighter transition-colors" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Almacenaje y "Cross-Docking"
                </h3>
                <p className="text-black dark:text-gray-300 text-[21px] font-medium leading-snug italic transition-colors mt-2">
                  Recibimos tu mercancía en nuestras sedes y la redistribuimos de inmediato. Menos tiempo en bodega.
                </p>
              </div>

              {/* Contenedor de la imagen inferior */}
              <div className="hidden sm:block w-36 h-24 rounded-3xl overflow-hidden shadow-sm bg-black/5 dark:bg-white/5 border-[1px] border-transparent dark:border-white/20 transition-colors flex-shrink-0 ml-6">
                <img src="imagen2.jpg" alt="Servicio Claro" className="w-full h-full object-cover block dark:hidden" />
                <img src="imagen2.jpg" alt="Servicio Oscuro" className="w-full h-full object-cover hidden dark:block" />
              </div>
            </div>

            {/* TARJETA 3 */}
            <div className="border-[1.5px] border-black dark:border-white rounded-[3rem] flex flex-row items-center p-6 shadow-2xl relative overflow-hidden h-auto transition-all duration-500
      bg-gradient-to-b from-white to-[#F08888]
      dark:from-[#590000] dark:to-[#780000]"
            >
              {/* Contenedor del ícono */}
              <div className="flex-shrink-0 flex justify-center items-center w-24 h-24 relative">
                <img src="png3.png" alt="Distribución Claro" className="w-20 h-20 object-contain drop-shadow-lg dark:hidden" />
                <img src="png3_oscuro.png" alt="Distribución Oscuro" className="w-20 h-20 object-contain drop-shadow-[0_10px_20px_rgba(255,255,255,0.1)] hidden dark:block" />
              </div>

              {/* Texto agrupado para alineación horizontal en móvil */}
              <div className="flex-grow flex flex-col items-start text-left mt-0 ml-6">
                <h3 className="text-[27px] font-bold text-black dark:text-white uppercase leading-tight tracking-tighter transition-colors" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Distribución Regional (Pachuca-Toluca-CDMX)
                </h3>
                <p className="text-black dark:text-gray-300 text-[21px] font-medium leading-snug italic transition-colors mt-2">
                  Conectamos los puntos estratégicos del comercio en México. Entregas locales y regionales con tiempos récord.
                </p>
              </div>

              {/* Contenedor de la imagen inferior */}
              <div className="hidden sm:block w-36 h-24 rounded-3xl overflow-hidden shadow-sm bg-black/5 dark:bg-white/5 border-[1px] border-transparent dark:border-white/20 transition-colors flex-shrink-0 ml-6">
                <img src="imagen3.jpg" alt="Servicio Claro" className="w-full h-full object-cover block dark:hidden" />
                <img src="imagen3.jpg" alt="Servicio Oscuro" className="w-full h-full object-cover hidden dark:block" />
              </div>
            </div>
          </div>
        ) : (
          /* WEB / ESCRITORIO: Tarjetas originales intactas */
          <div className="mt-0 w-full max-w-5xl grid grid-cols-1 md:grid-cols-3 gap-8 mb-0 px-4 md:px-0">
            {/* TARJETA 1 */}
            <div className="border-[1.5px] border-black dark:border-white rounded-[3rem] flex flex-col items-center p-8 shadow-2xl relative overflow-hidden h-full transition-all duration-500
      bg-gradient-to-b from-white to-[#F08888]
      /* Fondo Oscuro: Tu degradado rojo TBT */
      dark:from-[#590000] dark:to-[#780000]"
            >
              {/* Contenedor del ícono */}
              <div className="mb-6 flex justify-center items-center h-24 relative">
                <img src="png1.png" alt="Carga Consolidada Claro" className="w-40 h-40 object-contain drop-shadow-lg dark:hidden" />
                <img src="png1_oscuro.png" alt="Carga Consolidada Oscuro" className="w-40 h-40 object-contain drop-shadow-[0_10px_20px_rgba(255,255,255,0.1)] hidden dark:block" />
              </div>

              <div className="h-20 flex items-center justify-center">
                <h3 className="text-[22px] font-bold text-black dark:text-white uppercase text-center leading-tight tracking-tighter transition-colors" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Carga Consolidada<br /> (LTL)
                </h3>
              </div>

              <div className="h-28 flex items-start justify-center mt-4">
                <p className="text-black dark:text-gray-300 text-[16px] font-medium text-center leading-snug italic transition-colors">
                  ¿No llenas un camión completo? Paga solo por el espacio que ocupas. Ideal para tarimas y mercancía pesada.
                </p>
              </div>

              {/* Contenedor de la imagen inferior */}
              <div className="w-full h-48 mt-auto rounded-3xl overflow-hidden shadow-sm bg-black/5 dark:bg-white/5 border-[1px] border-transparent dark:border-white/20 transition-colors">
                <img src="imagen1.jpg" alt="Servicio Claro" className="w-full h-full object-cover block dark:hidden" />
                <img src="imagen1.jpg" alt="Servicio Oscuro" className="w-full h-full object-cover hidden dark:block" />
              </div>
            </div>

            {/* TARJETA 2 */}
            <div className="border-[1.5px] border-black dark:border-white rounded-[3rem] flex flex-col items-center p-8 shadow-2xl relative overflow-hidden h-full transition-all duration-500
      bg-gradient-to-b from-white to-[#F08888]
      /* Fondo Oscuro: Tu degradado rojo TBT */
      dark:from-[#590000] dark:to-[#780000]"
            >
              <div className="mb-6 flex justify-center items-center h-24 relative">
                <img src="png2.png" alt="Almacenaje Claro" className="w-40 h-40 object-contain drop-shadow-lg dark:hidden" />
                <img src="png2_oscuro.png" alt="Almacenaje Oscuro" className="w-40 h-40 object-contain drop-shadow-[0_10px_20px_rgba(255,255,255,0.1)] hidden dark:block" />
              </div>

              <div className="h-20 flex items-center justify-center">
                <h3 className="text-[22px] font-bold text-black dark:text-white uppercase text-center leading-tight tracking-tighter transition-colors" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Almacenaje y<br /> "Cross-Docking"
                </h3>
              </div>

              <div className="h-28 flex items-start justify-center mt-4">
                <p className="text-black dark:text-gray-300 text-[16px] font-medium text-center leading-snug italic transition-colors">
                  Recibimos tu mercancía en nuestras sedes y la redistribuimos de inmediato. Menos tiempo en bodega.
                </p>
              </div>

              <div className="w-full h-48 mt-auto rounded-3xl overflow-hidden shadow-sm bg-black/5 dark:bg-white/5 border-[1px] border-transparent dark:border-white/20 transition-colors">
                <img src="imagen2.jpg" alt="Servicio Claro" className="w-full h-full object-cover block dark:hidden" />
                <img src="imagen2.jpg" alt="Servicio Oscuro" className="w-full h-full object-cover hidden dark:block" />
              </div>
            </div>

            {/* TARJETA 3 */}
            <div className="border-[1.5px] border-black dark:border-white rounded-[3rem] flex flex-col items-center p-8 shadow-2xl relative overflow-hidden h-full transition-all duration-500
      bg-gradient-to-b from-white to-[#F08888]
      /* Fondo Oscuro: Tu degradado rojo TBT */
      dark:from-[#590000] dark:to-[#780000]"
            >
              <div className="mb-6 flex justify-center items-center h-24 relative">
                <img src="png3.png" alt="Distribución Claro" className="w-40 h-40 object-contain drop-shadow-lg dark:hidden" />
                <img src="png3_oscuro.png" alt="Distribución Oscuro" className="w-40 h-40 object-contain drop-shadow-[0_10px_20px_rgba(255,255,255,0.1)] hidden dark:block" />
              </div>

              <div className="h-20 flex items-center justify-center">
                <h3 className="text-[22px] font-bold text-black dark:text-white uppercase text-center leading-tight tracking-tighter transition-colors" style={{ fontFamily: "'Secular One', sans-serif" }}>
                  Distribución Regional<br /> (Pachuca-Toluca-CDMX)
                </h3>
              </div>

              <div className="h-28 flex items-start justify-center mt-4">
                <p className="text-black dark:text-gray-300 text-[16px] font-medium text-center leading-snug italic transition-colors">
                  Conectamos los puntos estratégicos del comercio en México. Entregas locales y regionales con tiempos récord.
                </p>
              </div>

              <div className="w-full h-48 mt-auto rounded-3xl overflow-hidden shadow-sm bg-black/5 dark:bg-white/5 border-[1px] border-transparent dark:border-white/20 transition-colors">
                <img src="imagen3.jpg" alt="Servicio Claro" className="w-full h-full object-cover block dark:hidden" />
                <img src="imagen3.jpg" alt="Servicio Oscuro" className="w-full h-full object-cover hidden dark:block" />
              </div>
            </div>
          </div>
        )}

      </div>
    </PageTransition>
  );
}